<template lang="pug">
  div
    v-bottom-sheet(v-model="addonSheet" max-width="600px" scrollable)
      v-card(flat)
        v-card-text.pa-0(style="color: rgba(0, 0, 0, 1);")
          v-layout.my-6(v-if="isFetching")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          div(v-else)
            template(v-for="(addonprod, index) in addonProducts")
              v-divider.white(v-if="index !== 0")
              v-row.pa-4(no-gutters @click="openShowAddons(index)" :style="{'background-color': (addonprod.quantity >= 1  && !addonprod.showAddons)? $vuetify.theme.themes[$theme].infoT08 : ''}")
                v-col(cols="8")
                  div.s1.mb-1 {{ addonprod.quantity >= 1 ? addonprod.quantity + ' x ' + addonprod.name : addonprod.name }}
                  template(v-for="adon in addonprod.addons")
                    div.p2(v-if="adon.quantity_per_set > 0") + {{ adon.name }}
                v-col(cols="4" align="end")
                  div.s1 {{ ((addonprod.price + addonprod.addons.map(m => (m.price * m.quantity_per_set)).reduce((a, b) => a + b, 0)) * addonprod.quantity) | displayPrice }}
                  div.p2.primary400--text(v-if="productDiscount(addonprod)") - {{ productDiscount(addonprod) | displayPrice }}
              v-expand-transition
                div.px-4(v-if="addonprod.showAddons")
                  div.label.basic600--text.text-uppercase {{ $t('addons') }}
                  v-card.pa-2.mt-2(outlined)
                    template(v-for="addon in addonprod.addons")
                      v-row(no-gutters align="center")
                        v-col.my-2(cols="8")
                          v-checkbox.pt-0.mt-0(v-model="addon.quantity_per_set" color="primary" :value="1" hide-details :disabled="(addonInvDisabled(addon, addonprod.quantity) && addon.quantity_per_set < 1) || (addon.disable && addon.quantity_per_set < 1)" @change="addonprod.quantity === 0 ? addonprod.quantity = 1 : ''")
                            template(v-slot:label)
                              div.p1 {{ addon.name }}
                        v-col.my-2(cols="4" align="end")
                          div.p1 + {{ addon.price | displayPrice }}
                  v-row(justify="center")
                    v-layout.my-4
                      v-spacer
                      v-btn.my-auto(icon small @click="addonprod.quantity--" :disabled="addonprod.quantity < 1")
                        eva-icon.mt-1(name="minus-circle-outline" height="24" width="24" :fill="addonprod.quantity < 1 ? $vuetify.theme.themes[$theme].textColorDisabled : $vuetify.theme.themes[$theme].primary500")
                      v-layout.divbox.s1.my-auto.text-center.mx-3 
                        .s1.ma-auto {{ addonprod.quantity }}
                      v-btn.my-auto(icon small @click="addonprod.quantity++" :disabled="inv_disabled || checkAddonInv(addonprod)")
                        eva-icon.mt-1(name="plus-circle-outline" height="24" width="24" :fill="inv_disabled || checkAddonInv(addonprod) ? $vuetify.theme.themes[$theme].textColorDisabled : $vuetify.theme.themes[$theme].primary500")
                      v-spacer
          div.pa-4(align="center")
            v-btn(small color="primary500" outlined height="24" :style="{'background-color': $vuetify.theme.themes[$theme].basic600T08}" @click="addProduct" :disabled="!showAddButton || inv_disabled")
              eva-icon(name="plus-outline" height="14" width="14" style="margin-bottom: -2px; margin-left: -6px;x" :fill="!showAddButton || inv_disabled ? $vuetify.theme.themes[$theme].textColorDisabled : $vuetify.theme.themes[$theme].primary500")
              div.button-AA-tiny(:style="{'color': !showAddButton || inv_disabled ? $vuetify.theme.themes[$theme].textColorDisabled : $vuetify.theme.themes[$theme].primary500}") {{ $t('add_another') }}

          v-divider.basic300.mt-2

          v-layout.my-6(v-if="hasDiscountPermission")
            v-spacer
            .discount(v-if="discount")
              v-layout
                .s2.primary400--text(v-if="discount.isPercentage") {{ $t('discount') }}: {{ discount.value }}%
                .s2.primary400--text(v-else) {{ $t('discount') }}: {{ discount.value | displayPrice }}
                eva-icon.mt-1.ml-2(name="trash-outline" height="16" width="16" :fill="$vuetify.theme.themes[$theme].danger500" @click="discount = null")
            .button-Aa-medium.info500--text(v-else @click="openEditDiscount = true") {{ $t('add_discount') }}
            v-spacer

        v-card-actions
          v-spacer
          v-btn(color='white', text @click='addonSheet = !addonSheet')
            .button-Aa-medium.primary400--text {{ $t('cancel') }}
          v-btn.mr-2(v-if="addonProducts.length > 0" color='info500' depressed @click="clickSave()")
            .button-AA-medium.basic100--text {{ $t('save') }}

    .discount(style="max-width:500px")
      AddDiscount(v-if="openEditDiscount" :open.sync="openEditDiscount" :initialDiscount.sync="discount" @added="handleAddDiscount")

</template>

<script>
import { mapActions } from 'vuex'
import AddDiscount from '@/components/forms/AddDiscount.vue'

export default {
  name: 'Addons',
  components: { AddDiscount },
  props: {
    language: {
      type: String,
      default: 'en'
    },
    open: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default: () => ({})
    },
    inventory: {
      type: Object,
      default: () => ({})
    },
    hasDiscountPermission: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isFetching: false,
    addonProducts: [],
    addon_inv: [],
    openEditDiscount: false,
    discount: null
  }),
  computed: {
    addonSheet: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    finalProdAddon () {
      const fin = []
      this.addonProducts.forEach((o) => {
        o.discount = this.discount ? this.discount.value : 0
        o.show_discount_as_percentage = this.discount ? this.discount.isPercentage : false
        fin.push(o)
      })
      const tot = {
        parent_id: this.product.id,
        addon_products: fin
      }
      return tot
    },
    productName () {
      if (this.product.name) {
        return this.product.name.length > 30 ? this.product.name.substr(0, 30) + '...' : this.product.name
      } else {
        return 'Product'
      }
    },
    showAddButton () {
      if (this.addonProducts.length > 0) {
        return this.addonProducts[this.addonProducts.length - 1].quantity > 0
      } else {
        return false
      }
    },
    inv_disabled () {
      if (this.inventory.inv_enable) {
        if (this.inventory.inv_qty > this.addonProducts.map((m) => { return m.quantity }).reduce((total, num) => { return total + num })) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    total_addon_qty () {
      const a = []
      this.addonProducts.map((m) => { return m.addons.map((a) => { return { id: a.id, total_qty: a.quantity_per_set * m.quantity } }) }).forEach((o, index) => {
        if (index === 0) {
          o.forEach((p) => {
            a.push(p)
          })
        } else {
          o.forEach((p) => {
            a.filter(f => f.id === p.id)[0].total_qty += p.total_qty
          })
        }
      })
      return a
    }
  },
  mounted () {
    this.fetchAddonProducts()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchAddonProducts () {
      if (this.product.addon_products) {
        this.addonProducts = [...this.product.addon_products.map((m) => { return { ...m, showAddons: false } })]
        this.fetchAddons()
      } else {
        this.addonProducts.push({ ...this.product, showAddons: true })
        this.fetchAddons()
      }
      if (this.addonProducts.length === 1) {
        this.addonProducts[0].showAddons = true
      }
      if (this.addonProducts[0] && this.addonProducts[0].discount) {
        this.discount = { 
          value: this.addonProducts[0].discount || 0,
          isPercentage: this.addonProducts[0].show_discount_as_percentage || false
        }
      }
    },
    fetchAddons () {
      this.isFetching = true
      this.$axios.get(`/products/${this.product.id}/addons?page_size=-1`)
        .then((resp) => {
          this.addonProducts.forEach((o) => {
            resp.data.results.forEach((a) => {
              if (o.addons) {
                if (o.addons.filter(f => f.id === a.id).length === 0) {
                  o.addons.push({
                    id: a.id,
                    name: a.name,
                    description: a.description,
                    price: a.price,
                    quantity_per_set: 0
                  })
                }
              } else {
                this.$set(o, 'addons', resp.data.results.map((m) => {
                  return {
                    id: m.id,
                    name: m.name,
                    description: m.description,
                    price: m.price,
                    quantity_per_set: 0
                  }
                }))
              }
              // o.addons.map(m => { return m.total_qty = [] })
            })
          })
          resp.data.results.forEach((b) => {
            this.addon_inv.push({ id: b.id, inv_enable: b.inventory_enabled, inv_qty: b.inventory_qty })
          })
        })
        .catch((resp) => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          console.log(resp)
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    addProduct () {
      this.closeShowAddons()
      this.$axios.get(`/products/${this.product.id}/addons`)
        .then((resp) => {
          const newaddonprod = {
            ...this.product,
            quantity: 0,
            addons: resp.data.results.map((m) => {
              return {
                id: m.id,
                name: m.name,
                description: m.description,
                price: m.price,
                quantity_per_set: 0
              }
            }),
            showAddons: true
          }
          this.addonProducts.push(newaddonprod)
        })
        .catch((resp) => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          console.log(resp)
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    addonInvDisabled (addon, prodqty) {
      const addinv = this.addon_inv.filter(f => f.id === addon.id)[0]
      if (addinv.inv_enable) {
        const a = this.total_addon_qty.filter(f => f.id === addon.id)[0].total_qty
        if (prodqty > 0) {
          if ((a + (1 * prodqty)) > addinv.inv_qty) {
            this.$set(addon, 'disable', true)
            return true
          } else {
            this.$set(addon, 'disable', false)
            return false
          }
        } else {
          this.$set(addon, 'quantity_per_set', 0)
          if ((a + 1) > addinv.inv_qty) {
            this.$set(addon, 'disable', true)
            return true
          } else {
            this.$set(addon, 'disable', false)
            return false
          }
        }
      } else {
        this.$set(addon, 'disable', false)
        return false
      }
    },
    checkAddonInv (prod) {
      const ar = []
      prod.addons.forEach((o) => {
        const addinv = this.addon_inv.filter(f => f.id === o.id)[0]
        const tot = this.total_addon_qty.filter(f => f.id === o.id)[0]
        if (addinv.inv_enable) {
          if (o.quantity_per_set > 0) {
            if ((tot.total_qty + o.quantity_per_set) > addinv.inv_qty) {
              ar.push(true)
            } else {
              // ar.push(o.disable)
            }
          } else {
            ar.push(false)
          }
        } else {
          ar.push(false)
        }
      })
      return ar.includes(true)
    },
    productDiscount (product) {
      if (!this.discount) {
        return 0
      }
      let discountAmount = this.discount.value
      if (this.discount.isPercentage) {
        discountAmount = this.discount.value * product.price /this.$currency.multiplier
      }
      return parseInt(discountAmount) * product.quantity
    },
    openShowAddons (idx) {
      this.addonProducts.forEach((o, index) => {
        if (index != idx) {
          this.$set(o, 'showAddons', false)
        }
      })
      this.$set(this.addonProducts[idx], 'showAddons', !this.addonProducts[idx].showAddons)
    },
    closeShowAddons () {
      this.addonProducts.forEach((o) => {
        this.$set(o, 'showAddons', false)
      })
    },
    handleAddDiscount (val) {
      this.discount = val
    },
    clickSave () {
      this.$emit('finalProdAddon', this.finalProdAddon)
      this.addonSheet = false
    }
  }
}
</script>

<style lang="scss" scoped>
.divbox {
  border: 2px solid var(--v-basic400);
  background-color: var(--v-basic200);
  height: 40px;
  max-width: 60px;
  border-radius: 5px;
}
</style>
